export default __webpack_public_path__ + "static/media/logo_p_small.d151f839.png";